export default [
    {
        header: true,
        title: ''
    },
    {
        title: 'ホーム （案件管理）',
        icon: 'home',
        href: '/worker/dashboard',
    },
    {
        title: 'お気に入り',
        icon: 'heart',
        href: '/worker/favorite',
    },
    {
        title: '案件検索',
        icon: 'search',
        href: '/worker/search'
    },
    {
        title: 'プロフィール',
        icon: 'user',
        href: '/worker/register/profile'
    },
    {
        title: 'メッセージ',
        icon: 'comments',
        href: '/worker/messager',
    },
    {
        title: 'マイ評価',
        icon: 'star',
        href: '/worker/company/rating/detail',
    },
    {
        title: '各種設定',
        icon: 'cog',
        href: '/worker/setting',
    },
    {
        title: 'お問い合わせ',
        icon: 'envelope',
        href: '/worker/contact',
    },
    {
        title: 'ヘルプ',
        icon: 'question-circle',
        href: '/worker/help',
    },

]
